import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import PaiLink from 'features/ui/base-components/pai-link';
import PaiTextField from 'features/ui/base-components/pai-text-field';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import isEmail from 'validator/lib/isEmail';

interface Props {
  open: boolean;
  loading: boolean;
  adminEmail: string;
  userEmail: string;
  password: string;
  helperTextUsername: string;
  helperTextPassword: string;
  handlePasswordChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSignIn: () => void;
  handleClose: () => void;
}

const AdminLoginDialog: React.FC<Props> = ({
  open,
  loading,
  adminEmail,
  userEmail,
  password,
  helperTextUsername,
  helperTextPassword,
  handlePasswordChange,
  handleSignIn,
  handleClose,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const isAllValid = () => password.trim() !== '' && isEmail(userEmail);

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' && isAllValid()) {
      handleSignIn();
    }
  };

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('adminLogin')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={2}>
          <PaiTextField
            placeholder={t('userEmail')}
            value={userEmail}
            onChange={() => {}}
            variant={'background'}
            error={helperTextUsername !== ''}
            errorText={helperTextUsername}
            disabled
          />
          <PaiTextField
            placeholder={t('adminEmail')}
            value={adminEmail}
            onChange={() => {}}
            variant={'background'}
            error={helperTextUsername !== ''}
            errorText={helperTextUsername}
            disabled
          />
          <PaiTextField
            placeholder={t('password')}
            value={password}
            onChange={handlePasswordChange}
            type={'password'}
            error={helperTextPassword !== ''}
            errorText={helperTextPassword}
            onKeyDown={handleKeyDown}
          />
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'md'} underline={'always'} action={handleClose} />
        <PaiButton text={t('signIn')} border={'rounded'} size={'small'} action={handleSignIn} disabled={!isAllValid()} loading={loading} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: 'linear-gradient(to right, #5044FF, #4AA4FF)',
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '20px 24px !important',
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default AdminLoginDialog;
